import { Easing } from '@tweenjs/tween.js';
import AnimationClip from '../AnimationClip';
import GameObject from '../../../GameObject/GameObject';
import TransformComponent from '../../../Component/Transform';

export class RockIdle extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const transform: TransformComponent = gameObject.getComponent(
            TransformComponent
        );

        const tween = this.getTween(transform);

        transform.rotation = -Math.PI / 12;

        tween
            .to({ rotation: Math.PI / 12 }, 2000)
            .easing(Easing.Quadratic.InOut)
            .yoyo(true)
            .repeat(Infinity);

        yield* this.startTween(tween);
    }
}
